import { put, takeLatest, call } from 'redux-saga/effects'

import * as orderService from '../../../services/orderService'
import {
  UNDELIVER_ORDER,
  UNDELIVER_ORDER_SUCCESS,
  UNDELIVER_ORDER_ERROR
}
  from '../../actions/order'

function * unDeliverOrderSaga (action) {
  try {
    const data = yield call(orderService.UnDeliverOrder, action.payload)

    yield put({
      type: UNDELIVER_ORDER_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: UNDELIVER_ORDER_ERROR, error: error.data
    })
  }
}

export function * unDeliverOrderSagaWatcher () {
  yield takeLatest(UNDELIVER_ORDER, unDeliverOrderSaga)
}
